"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserLogoutConfirmedEvent = exports.Name = void 0;
const Name = exports.Name = 'user-logout-confirmed';
const UserLogoutConfirmedEvent = exports.UserLogoutConfirmedEvent = Name;
